<template>
    <div>
        <div v-if="screen==='black'">

        </div>

        <div v-else-if="screen==='welcome'" class="welcome">
            <div class="text-right">
                <img src="./images/ship.png" class="logo" />
            </div>

            <div v-if="config.settings.ship">
                <h1 >{{config.settings.ship}}</h1>
                <img src="./images/welcome.jpg" class="lounge" />
            </div>
            <div v-else>
                <img src="./images/welcome_generic.jpg" class="lounge" />
            </div>

            <h3>
                Ship Services
            </h3>
            <div class="url">http://escit.tk/#/{{code}}</div>
        </div>

        <div v-else-if="screen==='countdown'" class='countdown'>
            <div class="url">
                http://escit.tk/#/{{code}}
            </div>

            <div class="warning-message">
                <h1 class="blink_me">WARNING</h1>
                <h2 v-if="destruct">SELF DESTRUCT SEQUENCE ACTIVATED</h2>
            </div>

            <div class="leftside"></div>
            <div class="rightside"></div>

            <div class='wrapper'>
                <span class="timer">
                    <span v-if="room.hours !== '00'">{{room.hours}}:</span>{{room.minutes}}:{{room.seconds}}.{{room.milliseconds}}
                </span>
            </div>

        </div>

        <div v-else-if="screen==='deactivated'" class='deactivated'>
            <div class="warning-message">
                <h1 class="deactivated">DEACTIVATED</h1>
                <h2 v-if="destruct">SELF DESTRUCT SEQUENCE</h2>
            </div>

            <img class="party blink_me" src="./images/party.png" />
            <div class="finished_with">Finished with <span v-if="room.hours !== '00'">{{room.hours}}:</span>{{room.minutes}}:{{room.seconds}}.{{room.milliseconds}} Remaining</div>
        </div>

        <div v-else-if="screen==='dead'" class='dead'>
            <img src="./images/dead.jpg">
            <p>I'm sorry.  You didn't make it.<br>
                Your ship has exploded.</p>
        </div>
    </div>
</template>

<script>
    let ambient = new Audio(require('./sounds/ambient.mp3'));
    let destruct = new Audio(require('./sounds/selfdestruct.mp3'));
    let alarm = new Audio(require('./sounds/alarm.mp3'));
    let morse = new Audio(require('./sounds/morse.mp3'));
    let explosion = new Audio(require('./sounds/explosion.mp3'));
    let deactivated = new Audio(require('./sounds/deactivated.mp3'));
    let power = new Audio(require('./sounds/power.mp3'));
    let dead = new Audio(require('./sounds/dead.mp3'));

    export default {
        name: 'Kit1Display',
        props: ['message','code','config','room'],
        data: function () {
            return {
                screen: 'black',
                destruct: true
            }
        },
        methods: {
            dead: function() {
                console.log('Room failed.');
                this.room.time = 0;
                this.room.status = 'failed';
                let self = this;
                dead.play();
                setTimeout(function() {
                    ambient.load();
                    self.screen = 'dead';
                }, 7000);
            }
        },
        watch: {
            message: function (payload) {
                if (payload.cmd === 'message' || payload.cmd === 'broadcast') {
                    let msg = payload.data;
                    switch (msg.cmd) {
                        case 'play':
                            if (msg.data.sound === 'ambient') ambient.play();
                            if (msg.data.sound === 'prepare') {
                                ambient.play();
                                this.screen = 'welcome';
                            }
                            if (msg.data.sound === 'destruct') {
                                let self = this;

                                destruct.play();
                                setTimeout(function() { self.screen = 'black';}, 4000);
                                setTimeout(function() { self.screen = 'welcome'; }, 4200);
                                setTimeout(function() { self.screen = 'black';}, 4300);
                                setTimeout(function() { self.screen = 'welcome'; }, 4400);
                                setTimeout(function() { self.screen = 'black'; }, 5000);
                                setTimeout(function() { self.screen = 'welcome';}, 5400);
                                setTimeout(function() { self.screen = 'black'; }, 6000);

                                setTimeout(function() {
                                    self.room.finishTime = new Date().getTime() + 3600000;
                                    self.room.status = 'running';
                                    self.screen = 'countdown';
                                }, 26000);
                            }
                            if (msg.data.sound === 'alarm') alarm.play();
                            if (msg.data.sound === 'morse') morse.play();
                            if (msg.data.sound === 'explosion') explosion.play();
                            if (msg.data.sound === 'deactivated') {
                                deactivated.play();
                                this.screen = 'deactivated';
                                this.room.status = 'success';
                            }
                            if (msg.data.sound === 'power') power.play();
                            if (msg.data.sound === 'dead') this.dead();
                            break;
                        case 'stop':
                            if (msg.data.sound === 'ambient') ambient.load();
                            if (msg.data.sound === 'destruct') destruct.load();
                            if (msg.data.sound === 'alarm') alarm.load();
                            if (msg.data.sound === 'morse') morse.load();
                            if (msg.data.sound === 'explosion') explosion.load();
                            if (msg.data.sound === 'deactivated') deactivated.load();
                            if (msg.data.sound === 'power') power.load();
                            if (msg.data.sound === 'dead') dead.load();
                            break;
                        case 'screen':
                            this.screen = msg.data.screen;
                            break;
                    }
                }
            },
            'room.time': function(value) {
                if (value <= 100 && this.room.status === 'running') {
                    this.dead();
                }
            }
        },
        created: function() {
            if (this.room.status === 'prepared') {
                ambient.play();
                this.screen = 'welcome';
            }
            if (this.room.status === 'running') {
                ambient.play();
                this.screen = 'countdown';
            }
            if (this.room.status === 'failed') this.screen = 'dead';
            if (this.room.status === 'success') this.screen = 'deactivated';
        }
    }
</script>

<style lang="scss" scoped>
    .welcome {
        text-align: left;

        img.lounge {
            max-width: 60%;
        }

        img.logo {
            width: 25%;
        }

        h1 {
            font-family: "Roboto", sans-serif;
            font-size: 110px;
            text-transform: uppercase;
        }

        h3 {
            margin-top: 50px;
            text-transform: uppercase;
            font-size: 18px;
        }

        .url {
            text-transform: uppercase;
            letter-spacing: 10px;
            font-size: 28px;
        }
    }

    .countdown {

        .ship-name {
            position: absolute;
            top: 25px;
            left: 0;
            right: 0;
            text-align: center;
            text-transform: uppercase;
            letter-spacing: 20px;
        }

        .warning-message {
            position: absolute;
            top: 100px;
            left: 0;
            right: 0;
            text-align: center;

            h1 {
                font-size: 150px;
                letter-spacing: 20px;
                background: red;
                color: black;
                margin-top: 50px;

                &.deactivated {
                    background: green !important;
                }
            }

            h2 {
                font-size: 50px;
                letter-spacing: 10px;
                background: white;
                color: black;
                margin-top: 50px;
                padding: 15px;
            }

            z-index: 1000;
        }

        .blink_me {
            animation: blinker 1.5s linear infinite;
        }

        @keyframes blinker {
            50% {
                opacity: 0;
            }
        }

        .leftside {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;

            width: 300px;
            background: url('./images/red_stripes.jpg');
        }

        .rightside {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;

            width: 300px;
            background: url('./images/red_stripes_r.jpg');
        }

        .wrapper {
            margin: 100px auto 0;
            width: 900px;
            position: absolute;
            top: 550px;
            left: 0;
            right: 0;
            border: 5px solid red;
            text-align: center;
            line-height: 200px;
            .timer {
                font-family: "Lucida Console", Monaco, monospace;
                font-size: 178px;

                display: block;
                color: red;
                margin: 0;
            }
        }

        .url {
            position: absolute;
            top: 30px;
            left: 0;
            right: 0;
            text-align: center;
            letter-spacing: 8px;
            text-transform: uppercase;
            font-family: "Lucida Console", Monaco, monospace;
            font-size: 28px;
        }

        @media (max-width: 1500px) {
            .leftside, .rightside {
                width: 200px;
            }
        }

        @media (max-width: 1200px) {
            .leftside, .rightside {
                width: 100px;
            }
        }

        @media (max-width: 1100px) {
            .warning-message {
                h1 {
                    font-size: 100px;
                }
                h2 {
                    font-size: 30px;
                }
            }

            .wrapper {
                top: 370px;
                width: 700px;
                .timer {
                    font-size: 120px;
                }
            }
        }
    }

    .deactivated {
        .warning-message {
            position: absolute;
            top: 100px;
            left: 0;
            right: 0;
            text-align: center;

            h1 {
                font-size: 150px;
                letter-spacing: 20px;
                background: green;
                color: black;
                margin-top: 50px;
            }

            h2 {
                font-size: 50px;
                letter-spacing: 10px;
                background: white;
                color: black;
                margin-top: 50px;
                padding: 15px;
            }

            z-index: 1000;
        }

        .party {
            position: absolute;
            margin: auto;
            bottom: 200px;
            left: 0;
            right: 0;
            width: 50px;
        }

        .blink_me {
            animation: blinker 1.5s linear infinite;
        }

        @keyframes blinker {
            50% {
                opacity: 0;
            }
        }

        .finished_with {
            position: absolute;
            margin: auto;
            bottom: 100px;
            left: 0;
            right: 0;
            font-size: 24px;
            color: #333;
        }
    }

    .dead {
        text-align: center;
        font-size: 50px;
        padding-top: 80px;
    }
</style>


// WEBPACK FOOTER //
// src/kits/1/display.vue